import { call, put } from "redux-saga/effects";
import { getDealActivitiesLogList, getDealLogList, getModuleLookup } from "../../../../Services/apiService";
import { getDealActivitiesFailure, getDealActivitiesSuccess, getDealLogFailure, getDealLogSuccess, getModuleLookupFailure, getModuleLookupSuccess } from "../../../Slices/dealSlice";

export function* getDealLogHandler(actions) {
    try {
        let response = yield call(getDealLogList, actions?.payload);
        yield put(getDealLogSuccess(response?.data));
    } catch (err) {
        yield put(getDealLogFailure(err?.response?.data));
    }
}

export function* getDealActivitiesHandler(actions) {
    try {
        let response = yield call(getDealActivitiesLogList, actions?.payload);
        yield put(getDealActivitiesSuccess(response?.data));
    } catch (err) {
        yield put(getDealActivitiesFailure(err?.response?.data));
    }
}

export function* getModuleLookupHandler(actions) {
    try {
        let response = yield call(getModuleLookup, actions?.payload);
        yield put(getModuleLookupSuccess(response?.data));
    } catch (err) {
        yield put(getModuleLookupFailure(err?.response?.data));
    }
}